import { useState, useEffect } from "react";
import "./product.scss";
import { NavLink } from "react-router-dom";

const Product = ({
  title = true,
  dis = false,
  // image = true,
  link = "/",
  price = true,
  maker = true,
  star = true,
  data,
}) => {
  return (
    <div className="Product px-3">
      <NavLink
        to={`/product/${data.id}/${data.businesses_id}`}
        className="h-100"
      >
        <div
          className="bg-light item text-center p-4 mx-auto border border-3  
          "
        >
          <img
            src={`http://marketgroup.tatdemo.ir/${data.image}`}
            // src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Pitch_class_space_star.svg/330px-Pitch_class_space_star.svg.png"
            width={195}
            height={195}
            alt
            className="img-product"
          />
          <div className="bg-white item-title w-100 p-2 mt-3">
            <div className="p-1">
              <div className="main-text2">
                <p className="text-color text-center" style={{ fontSize: 14 }}>
                  {title && <p>{data.name}</p>}
                </p>
              </div>
            </div>
            {dis && (
              <div className="p-4">
                <div className="main-text">
                  <p
                    className="text-color text-center"
                    style={{ fontSize: 14 }}
                  >
                    {data.dis}
                  </p>
                </div>
              </div>
            )}
            <div className=" d-flex flex-row justify-content-between">
              {maker && (
                <p className="text-secondary small-font">{data.brand}</p>
              )}
              <div className=" d-flex flex-row">
                {star && (
                  <>
                    <small className="pt-1 text-secondary small-font">
                      ({data.score_count})
                    </small>
                    <p className="mx-1 text-secondary small-font">
                      {data.score}
                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={19}
                      height={21}
                      viewBox="0 0 19 21"
                    >
                      <path
                        id="Icon_awesome-star"
                        data-name="Icon awesome-star"
                        d="M9.922.73,7.6,6.159l-5.189.874a1.374,1.374,0,0,0-.629,2.239L5.54,13.5l-.888,5.967c-.16,1.079.824,1.886,1.648,1.382l4.642-2.817,4.642,2.817c.824.5,1.808-.3,1.648-1.382L16.343,13.5,20.1,9.272a1.374,1.374,0,0,0-.629-2.239L14.28,6.159,11.961.73a1.076,1.076,0,0,0-2.039,0Z"
                        transform="translate(-1.441 0.001)"
                        fill="#eca72c"
                      />
                    </svg>
                  </>
                )}
              </div>
            </div>
            <div className=" d-flex flex-row justify-content-between">
              {price && (
                <>
                  <p className="small-font text-d">
                    {parseInt(data.price).toLocaleString()}
                    {/* <small>تومان</small> */}
                  </p>
                  {data.discount != 0 ? (
                    <p>
                      {(
                        parseInt(data.price) - parseInt(data.discount)
                      ).toLocaleString()}{" "}
                      <small>تومان</small>
                    </p>
                  ) : (
                    ""
                  )}
                  <button className="btn btn-light eye-btn pt-1 small">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="eye-icon"
                      width="17.066"
                      height="10.5"
                      viewBox="0 0 17.066 11.5"
                    >
                      <path
                        id="Icon_ionic-md-eye"
                        data-name="Icon ionic-md-eye"
                        d="M10.783,7.383a9.176,9.176,0,0,0-8.533,5.75,9.207,9.207,0,0,0,17.066,0A9.176,9.176,0,0,0,10.783,7.383Zm0,9.585a3.835,3.835,0,1,1,3.878-3.835A3.867,3.867,0,0,1,10.783,16.967Zm0-6.135a2.3,2.3,0,1,0,2.328,2.3A2.321,2.321,0,0,0,10.783,10.833Z"
                        transform="translate(-2.25 -7.383)"
                        fill="#011c40"
                      />
                    </svg>
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </NavLink>
    </div>
  );
};

export default Product;
